export const BRAND = {
  name: "KAME",
  subtitle: "AUTOPŮJČOVNA",
  phones: ["+420 775 620 120", "+420 725 084 844", "+420 721 312 238"],
  email: "kameautopujcovna@gmail.com",
  address: {
    street: "Hradecká 2152/35",
    city: "621 00 Brno-Řečkovice",
    part: "a Mokrá Hora",
    full: "Hradecká 2152/35, 621 00 Brno-Řečkovice a Mokrá Hora",
  },
  web: "www.kameautopujcovna.cz",
  hours: [
    { days: "Pondělí – Pátek", time: "8:00 – 16:00" },
    { days: "Sobota – Neděle", time: "8:00 – 12:00" },
  ],
  values: ["RYCHLE", "BEZPEČNĚ", "NONSTOP", "KVALITA", "SPOLEHLIVOST", "FLEXIBILITA"],
};

export const NAV_LINKS = [
  { to: "/", label: "Úvod" },
  { to: "/vozovy-park", label: "Vozový park" },
  { to: "/cenik", label: "Ceník" },
  { to: "/podminky", label: "Podmínky" },
  { to: "/o-nas", label: "O nás" },
  { to: "/kontakt", label: "Kontakt" },
];
